import React from "react";
import PropTypes from "prop-types";
import { ContentCard, EmptyState, Icon } from "@weezevent/nacre";

const CheckpointsEmptyState = ({
	title,
	subtitle,
	labelButton,
	iconName,
	onClick
}) => {
	return (
		<ContentCard>
			<EmptyState
				title={title}
				subtitle={subtitle ?? null}
				icon={<Icon name={iconName} />}
				labelButton={labelButton ?? null}
				onClick={onClick}
			/>
		</ContentCard>
	);
};

CheckpointsEmptyState.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	labelButton: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	iconName: PropTypes.string,
	onClick: PropTypes.func
};

CheckpointsEmptyState.defaultProps = {
	subtitle: null,
	labelButton: null,
	iconName: "list",
	onClick: undefined
};

export default CheckpointsEmptyState;
